import usersDailyWidgetTemplate from './usersDailyWidget.html';
import './usersDailyWidget.scss';

export default angular
  .module('main.dashboardPanel.usersDailyWidget', [])

  .directive('usersDailyWidget', () => {
    return {
      restrict: 'E',
      template: usersDailyWidgetTemplate,
      scope: {},
      controller: ($scope,
                   $filter,
                   utils,
                   DashboardDataProvider) => {
        const $t = $filter('translate');

        $scope.noData = false;
        $scope.loading = true;

        init();

        function init() {

          DashboardDataProvider.getUsers(moment(DashboardDataProvider.now).subtract(1, 'w').valueOf(), moment(DashboardDataProvider.now).endOf('d').valueOf())
            .then((reportInfo) => {
              $scope.loading = false;
              if (!reportInfo || !reportInfo.dictionary || reportInfo.dictionary.length <= 0 || !reportInfo.executions || reportInfo.executions.length <= 0) {
                $scope.noData = true;
                return;
              }

              let dailyActiveUsers = reportInfo.executions
                .slice()
                .sort((a, b) => a.executionDateMs - b.executionDateMs) // latest last
                .map(execution => ({
                  x: execution.executionDateMs,
                  y: execution.data?.find(d => d.id === 3)?.value
                }));

              let dailyInactiveUsers = reportInfo.executions
                .slice()
                .sort((a, b) => a.executionDateMs - b.executionDateMs) // latest last
                .map(execution => ({
                  x: execution.executionDateMs,
                  y: execution.data?.find(d => d.id === 1)?.value - execution.data?.find(d => d.id === 3)?.value
                }));

              $scope.series = [
                {
                  data: dailyActiveUsers,
                  label: $t('dash.panel.reports.dailyActiveUsers.activeUsers'),
                  color: 'blue'
                },
                {
                  data: dailyInactiveUsers,
                  label: $t('dash.panel.reports.dailyActiveUsers.inactiveUsers'),
                  color: 'gray'
                }
              ];
            }, (err) => {
              utils.handleApiError(err);
              $scope.noData = true;
              $scope.loading = false;
            });
        }
      }
    };
  })
  .name;
